










































































































import { FinanceType, PaymentInOutFlowType, TransactionType, WhtAmountType } from "@/enums/enums";
import { GetPaymentInOutFlowType, GetWhtPaymentPercent } from "@/helper/paymentHelper";
import peakUtility from "@/helper/peakUtility";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { namespace } from "vuex-class";
import DropdownPaymentBankAccount from "./componentPayment/DropdownPaymentBankAccount.vue";
import DropdownPaymentWht from "./componentPayment/DropdownPaymentWht.vue";
import DropdownPaymentWhtPnd from "./componentPayment/DropdownPaymentWhtPnd.vue";

const StoreTransaction = namespace("Transaction");

@Component({ components: { DropdownPaymentBankAccount, DropdownPaymentWht, DropdownPaymentWhtPnd } })
export default class SectionPayment extends Vue {
  @Prop({}) readonly transactionCreate!: any;

  private isNotSuggestionPaymentPnd = false;

  @StoreTransaction.Mutation
  private MutationOnChangeWhtPayment!: (input: any) => void;

  @StoreTransaction.Mutation
  private MutationOnChangePaymentGroup!: (transactionCreate: any) => void;

  get paymentInOutFlowType() {
    return GetPaymentInOutFlowType(this.transactionCreate.transactionType, this.transactionCreate.financeType);
  }

  get isAutoHidePayment() {
    let isAutoHidePayment = false;
    if (
      this.transactionCreate &&
      this.transactionCreate.transactionType === TransactionType.Invoice &&
      this.transactionCreate.financeType === FinanceType.OutFlow
    ) {
      if (
        !(
          this.transactionCreate.payment &&
          this.transactionCreate.payment.paymentGroupList &&
          this.transactionCreate.payment.paymentGroupList.length > 0 &&
          (this.transactionCreate.payment.paymentGroupList[0].paymentTransactionChartAccountActived ||
            this.transactionCreate.payment.paymentGroupList[0].paymentTransactionBankAccountList.length > 1)
        )
      ) {
        isAutoHidePayment = true;
      }
    }
    return isAutoHidePayment;
  }

  get isLockPayment() {
    return (
      this.paymentInOutFlowType === PaymentInOutFlowType.CashOut &&
      !this.transactionCreate.transactionSummary.isNoneOrNotSpecifyWht
    );
  }

  get remainPaymentNetAmount() {
    return this.transactionCreate.transactionSummary.netAmount.ToNumber();
  }

  get remainWhtPaymentNetAmount() {
    return this.transactionCreate.transactionSummary.paymentWht.whtTotal.ToNumber();
  }

  get subTotalForCalculateWht() {
    return this.transactionCreate.transactionSummary.subTotalForCalculateWht.ToNumber();
  }

  get netAmount() {
    return this.transactionCreate.transactionSummary.netAmount.ToNumber();
  }
  get paymentDisabled() {
    return this.transactionCreate.payment.disabled;
  }

  get paymentTransactionChartAccountTotal() {
    return this.transactionCreate.payment.paymentGroupList[0].paymentTransactionChartAccountTotal;
  }

  get getIsPaymentActive() {
    return this.transactionCreate.payment.paymentGroupList[0].isPaymentActive;
  }

  @Watch("isAutoHidePayment", { immediate: true })
  isAutoHidePaymentChanged(newValue: any, oldValue: any) {
    if (newValue && !oldValue) {
      this.transactionCreate.payment.paymentGroupList[0].isPaymentActive =
        this.transactionCreate.transactionSummary.netAmount.ToNumber() !== 0;
    }
  }

  @Watch("transactionCreate.transactionSummary.netAmount", { immediate: true })
  transactionSummaryNetAmountChanged() {
    if (this.isAutoHidePayment) {
      this.transactionCreate.payment.paymentGroupList[0].isPaymentActive =
        this.transactionCreate.transactionSummary.netAmount.ToNumber() !== 0;
    }
  }

  @Watch("transactionCreate.date.value", { immediate: true })
  dateValueChanged() {
    if (!this.transactionCreate.isNotAuto) {
      this.transactionCreate.payment.paymentGroupList[0].paymentGroupDate = this.transactionCreate.date.value;
    }
  }

  @Watch("isLockPayment", { immediate: true })
  isLockPaymentChanged() {
    this.SetLockWhtPayment(this.isLockPayment);
  }

  @Watch("remainWhtPaymentNetAmount", { deep: true })
  remainWhtPaymentNetAmountChanged() {
    if (!this.paymentDisabled && !this.transactionCreate.isNotSuggestionPayment) {
      this.SetSuggestionPaymentTotalFromNetAmount();
    } else if (this.transactionCreate.isNotSuggestionPayment) {
      this.isNotSuggestionPaymentPnd = true;
      this.transactionCreate.isNotSuggestionPayment = false;
    }
  }

  @Watch("remainPaymentNetAmount", { immediate: true, deep: true })
  remainPaymentNetAmountChanged() {
    if (!this.paymentDisabled && !this.transactionCreate.isNotSuggestionPayment) {
      this.SetSuggestionPaymentTotalFromNetAmount();
    } else if (this.transactionCreate.isNotSuggestionPayment) {
      this.isNotSuggestionPaymentPnd = true;
      this.transactionCreate.isNotSuggestionPayment = false;
    }
  }

  @Watch("getIsPaymentActive", { immediate: true, deep: true })
  isPaymentActiveChanged() {
    if (this.getIsPaymentActive) {
      this.SetSuggestionPaymentTotalFromNetAmount();
    }
  }

  @Watch("paymentTransactionChartAccountTotal", { deep: true })
  paymentTransactionChartAccountTotalChanged(newValue: any, oldValue: any) {
    if (newValue != oldValue) {
      this.OnChangePaymentTransactionChartAccountTotal(oldValue, newValue);
    }
  }

  public ShowSwitchComponent() {
    return this.transactionCreate.transactionType !== TransactionType.Receipt;
  }

  public HiddenPayment(paymentGroupIndex: any, open = false) {
    if (this.paymentInOutFlowType === PaymentInOutFlowType.CashOut) {
      if (open) {
        this.transactionCreate.payment.paymentGroupList[paymentGroupIndex].isPaymentActive = true;
      } else {
        this.transactionCreate.payment.paymentGroupList[paymentGroupIndex].isPaymentActive = this.transactionCreate
          .payment.paymentGroupList[paymentGroupIndex].isPaymentActive
          ? false
          : true;
      }
    }
  }

  public OnChangePaymentGroup() {
    this.$nextTick(() => {
      this.MutationOnChangePaymentGroup(this.transactionCreate);
      if (this.isLockPayment) {
        const paymentWht = peakUtility
          .PeakOperatorMultiply(
            peakUtility.PeakOperatorDivide(
              this.transactionCreate.payment.paymentGroupList[0].paymentGroupTotal,
              this.remainPaymentNetAmount
            ),
            this.remainWhtPaymentNetAmount
          )
          .ToAccountingRoundUp();
        this.SetSuggestionPaymentTotal(
          this.transactionCreate.payment.paymentGroupList[0].paymentGroupTotal,
          paymentWht
        );
      }
    });
  }

  public SetSuggestionPaymentTotal(paymentTotal: any, paymentWht: any) {
    const paymentTransactionBankAccountIndex = 0;
    const isCheckedWht = this.transactionCreate.payment.paymentGroupList[0].whtPayment.isWht;
    this.transactionCreate.payment.paymentGroupList[0].whtPayment.isWht = false;
    this.MutationOnChangeWhtPayment({
      transactionCreate: this.transactionCreate,
      paymentGroup: this.transactionCreate.payment.paymentGroupList[0],
    });

    this.transactionCreate.payment.paymentGroupList[0].paymentTransactionBankAccountList[
      paymentTransactionBankAccountIndex
    ].paymentAmount = (
      paymentTotal.ToNumber() -
      (this.transactionCreate.payment.paymentGroupList[0].paymentGroupTotal.ToNumber() -
        this.transactionCreate.payment.paymentGroupList[0].paymentTransactionBankAccountList[
          paymentTransactionBankAccountIndex
        ].paymentAmount.ToNumber())
    ).FormatMoney();
    this.MutationOnChangePaymentGroup(this.transactionCreate);
    if (!this.transactionCreate.isNotSuggestionPayment) {
      if (!this.transactionCreate.transactionSummary.isNoneOrNotSpecifyWht && paymentWht.ToAccountingRoundUp() != 0) {
        this.transactionCreate.payment.paymentGroupList[0].whtPayment.isWht = true;
        this.transactionCreate.payment.paymentGroupList[0].whtPayment.whtAmountTypeId = GetWhtPaymentPercent(
          this.subTotalForCalculateWht,
          paymentWht,
          this.netAmount,
          paymentTotal
        );
        this.transactionCreate.payment.paymentGroupList[0].whtPayment.whtAmount = paymentWht.FormatMoney();
        this.MutationOnChangeWhtPayment({
          transactionCreate: this.transactionCreate,
          paymentGroup: this.transactionCreate.payment.paymentGroupList[0],
          isFromEvent: true,
        });
      } else {
        this.transactionCreate.payment.paymentGroupList[0].whtPayment.whtAmount = "0.00";
        this.MutationOnChangePaymentGroup(this.transactionCreate);
      }
    } else if (isCheckedWht) {
      this.transactionCreate.payment.paymentGroupList[0].whtPayment.isWht = true;
      this.MutationOnChangeWhtPayment({
        transactionCreate: this.transactionCreate,
        paymentGroup: this.transactionCreate.payment.paymentGroupList[0],
        isFromEvent: true,
      });
    }
  }

  public OnBlurPaymentAmount(paymentAmount: any) {
    paymentAmount = paymentAmount.FormatMoney();
    this.OnChangePaymentGroup();
    return paymentAmount;
  }

  public UnActiveWht() {
    if (
      this.transactionCreate.payment.paymentGroupList[0].whtPayment.whtAmountTypeId !== WhtAmountType.Custom ||
      this.transactionCreate.payment.paymentGroupList[0].whtPayment.disabled
    ) {
      this.transactionCreate.payment.paymentGroupList[0].whtPayment.isWht = false;
      this.MutationOnChangeWhtPayment({
        transactionCreate: this.transactionCreate,
        paymentGroup: this.transactionCreate.payment.paymentGroupList[0],
        isFromEvent: true,
        isReturnWhtAmountToPayment: this.transactionCreate.payment.paymentGroupList[0].whtPayment.disabled,
      });
    }
  }

  public SetLockWhtPayment(isLock: boolean) {
    this.transactionCreate.payment.paymentGroupList[0].whtPayment.disabled = isLock;
  }

  public SetSuggestionPaymentTotalFromNetAmount() {
    this.SetSuggestionPaymentTotal(this.remainPaymentNetAmount, this.remainWhtPaymentNetAmount);
  }

  public OnChangePaymentTransactionChartAccountTotal(
    oldPaymentTransactionChartAccountTotal: any,
    newPaymentTransactionChartAccountTotal: any
  ) {
    const paymentTransactionBankAccountIndex = 0;
    this.transactionCreate.payment.paymentGroupList[0].paymentTransactionBankAccountList[
      paymentTransactionBankAccountIndex
    ].paymentAmount = peakUtility
      .PeakOperatorSubtract(
        peakUtility.PeakOperatorAdd(
          this.transactionCreate.payment.paymentGroupList[0].paymentTransactionBankAccountList[
            paymentTransactionBankAccountIndex
          ].paymentAmount.ToNumber(),
          oldPaymentTransactionChartAccountTotal
        ),
        newPaymentTransactionChartAccountTotal
      )
      .FormatMoney();
    this.OnChangePaymentGroup();
  }

  public OnBlurPaymentWhtAmount() {
    this.transactionCreate.payment.paymentGroupList[0].whtPayment.whtAmount = this.transactionCreate.payment.paymentGroupList[0].whtPayment.whtAmount.FormatMoney();
    this.OnChangePaymentGroup();
  }

  public OnClickWHtAmount() {
    this.transactionCreate.payment.paymentGroupList[0].whtPayment.whtAmountTypeId = WhtAmountType.Custom;
  }

  public OnChangeWhtPayment() {
    if (this.transactionCreate.payment.paymentGroupList[0].whtPayment.isWht) {
      this.transactionCreate.payment.paymentGroupList[0].whtPayment.whtAmountTypeId = WhtAmountType.ThreePercent;
    }
    this.MutationOnChangeWhtPayment({
      transactionCreate: this.transactionCreate,
      paymentGroup: this.transactionCreate.payment.paymentGroupList[0],
      isFromEvent: true,
    });
  }
}
